import { api } from "../../apiendpoints/index";
import axios from "axios";

export const Login = (userName, password) => {
  return axios.post(`${api.LOGIN.AUTH}`, {
    userName: userName,
    password: password,
  });
};

// export const LogoutApi = () => {
//   return axios.post(`${api.LOGIN.LOGOUT}`);
// };

export const ForgotEmail = (emailID) => {
  return axios.post(`${api.LOGIN.FORGOT_EMAIL}?UserLogin=${emailID}`);
};

export const IsEmailValid = (emailID) => {
  return axios.post(`${api.LOGIN.IS_EMAIL_VALID}?EmailAddress=${emailID}`);
};

export const StoreNewPassword = (emailID, newPassword) => {
  return axios.post(
    `${api.LOGIN.SET_NEW_PASSWORD}?EmailAddress=${emailID}&Password=${newPassword}`
  );
};
